import React from "react";
import {
  DefaultRouteParam,
  RouteConfig,
} from "../../../../../config/router/router.config";

export type MaintainerCreateRouteParam = DefaultRouteParam;

export const maintainerCreateRoute: RouteConfig = {
  name: "Create Maintainer",
  Component: React.lazy(() => import("./MaintainerCreate.view")),
  path: "/user/maintainer/create",
  isPrivate: true,
  roleLevelMax: 0,
};
